import Guid from '@/app/utils/guid'
import Entity from '@/common/models/entity'

export default class ProjectGroupTemplate extends Entity {
  public tenantId: Guid | null = null
  public name = ''
  public content = ''
  public directoryId: string | null = null
}
